import { Injectable } from '@angular/core';
import { IPeriodWithHolidays } from '@interfaces/IPeriod';
import { IAppState } from '@myStore/app.state';
import {
  EPeriodsViewActions,
  GetGroupPeriodsFailure,
  GetGroupPeriodsRequest,
  GetGroupPeriodsSuccess,
  GetPeriodFailure,
  GetPeriodRequest,
  GetPeriodSuccess,
} from '@myStore/periods-view/periods-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { PeriodsViewService } from '@services/periods-view/periods-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class PeriodsViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _periodViewService: PeriodsViewService
  ) {}

  $get = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetPeriodRequest>(EPeriodsViewActions.GetPeriodRequest),
        switchMap(action => {
          return this._periodViewService.get(action.periodId).pipe(
            map(res => {
              this._store.dispatch(new GetPeriodSuccess(res));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении периодов возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetPeriodFailure(err.errors));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getGroupPeriods = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetGroupPeriodsRequest>(
          EPeriodsViewActions.GetGroupPeriodsRequest
        ),
        switchMap(action => {
          return this._periodViewService.getGroupPeriods(action.groupId).pipe(
            map((periods: IPeriodWithHolidays[]) => {
              this._store.dispatch(new GetGroupPeriodsSuccess(periods));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении периода у группы возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetGroupPeriodsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
